<template lang="pug">
  div
    menu-dropdown
    div(v-if="!loading").loyalty-tabs
      ods-tabs(v-model="activeTab")
        ods-tab-pane(:label="$t('loyalty.templates')" name="templates" @click="activeTab='templates'")
          plantillas-table(v-if="activeTab==='templates'")
        ods-tab-pane(:label="$t('loyalty.coupons')" name="cupones" @click="activeTab='cupones'")
          cupones-tab(v-if="activeTab==='cupones'")
        // ods-tab-pane(:label="this.$t('loyalty.assignment')" name="asignaicones")
          asignaciones-table(:data="this.data" v-if="activeTab==='tab-asignaicones'")
</template>

<script>
import LoyaltyDropDown from '@/components/loyalty/LoyaltyDropDown'
import PlantillasTable from '@/components/loyalty/Coupons/PlantillasTable'
import CuponesTab from '@/components/loyalty/Coupons/CuponesTab'
// import AsignacionesTable from '@/components/loyalty/Coupons/AsignacionesTable'

export default {
  name: 'LoyaltyCoupons',
  data () {
    return {
      appProgram: '',
      activeTab: 'templates',
      loading: true
    }
  },
  components: {
    'menu-dropdown': LoyaltyDropDown,
    'plantillas-table': PlantillasTable,
    'cupones-tab': CuponesTab
    // 'asignaciones-table': AsignacionesTable
  },
  mounted () {
    this.loading = true
    const act = this.$route.query.activeTab
    setTimeout(() => {
      this.activeTab = act || 'templates'
      this.loading = false
    }, 200)
  },
  watch: {
    appProgram (newName) {
      this.loading = true
      this.appProgram = sessionStorage.getItem('appProgram')
      // console.log(`CAMBIA programa ${this.appProgram} ${newName}`)
      setTimeout(() => {
        this.loading = false
      }, 200)
    }
  }
}

</script>

<style lang="scss" scoped>
.loyalty-tabs{
  padding: rem(0) rem(16);
}
</style>
